(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tiles-slider')) {
    class TilesSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tiles-track]');
        this.prev = this.querySelector('[data-tiles-prev]');
        this.next = this.querySelector('[data-tiles-next]');
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
      }

      disconnectedCallback() {
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
      }

      onPrev = () => this.move(-1);
      onNext = () => this.move(1);

      move(direction) {
        if (!this.track) return;
        const item = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    customElements.define('tiles-slider', TilesSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onEditorSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onEditorSelect);
      }

      onClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.select(tab);
      };

      onKeydown = (event) => {
        const index = this.tabs.indexOf(document.activeElement);
        if (index === -1) return;
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.tabs[next].focus();
        this.select(this.tabs[next]);
      };

      onEditorSelect = (event) => {
        if (event.target instanceof Element && this.tabs.includes(event.target)) this.select(event.target);
      };

      select(activeTab) {
        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !isActive;
        });
      }
    }
    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-reels')) {
    class VideoReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-reels-track]');
        this.arrows = this.querySelector('[data-reels-arrows]');
        this.prev = this.querySelector('[data-reels-prev]');
        this.next = this.querySelector('[data-reels-next]');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.videos.forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.controls = this.reduceMotion;
        });

        if (!this.reduceMotion && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0.4 });
          this.videos.forEach((video) => this.observer.observe(video));
        }

        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.track?.addEventListener('scroll', this.updateArrows, { passive: true });
        if (this.track && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateArrows);
          this.resizeObserver.observe(this.track);
        }
        document.addEventListener('visibilitychange', this.onVisibility);
        this.updateArrows();

        // Auto-scroll
        if (this.dataset.autoScroll === 'true' && !this.reduceMotion) {
          this.autoInterval = Math.max(Number(this.dataset.autoInterval) || 4, 2) * 1000;
          this.startAutoScroll();
          // Pause on hover or touch
          this.addEventListener('pointerenter', this.stopAutoScroll);
          this.addEventListener('pointerleave', this.startAutoScroll);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.updateArrows);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.stopAutoScroll();
        this.removeEventListener('pointerenter', this.stopAutoScroll);
        this.removeEventListener('pointerleave', this.startAutoScroll);
        this.videos?.forEach((video) => video.pause());
      }

      /** @param {IntersectionObserverEntry[]} entries */
      onIntersect = (entries) => {
        for (const entry of entries) {
          const video = /** @type {HTMLVideoElement} */ (entry.target);
          video.dataset.inView = String(entry.isIntersecting);
          if (entry.isIntersecting && !document.hidden) {
            if (video.preload === 'none') video.preload = 'auto';
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      };

      onVisibility = () => {
        this.videos.forEach((video) => {
          if (document.hidden) video.pause();
          else if (video.dataset.inView === 'true' && !this.reduceMotion) video.play().catch(() => {});
        });
      };

      updateArrows = () => {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.arrows) this.arrows.hidden = max <= 1;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
      };

      onPrev = () => { this.resetAutoScroll(); this.move(-1); };
      onNext = () => { this.resetAutoScroll(); this.move(1); };

      /** @param {number} direction */
      move(direction) {
        if (!this.track) return;
        const item = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: direction * step, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      // Auto-scroll: advances one card at a time, loops back to the start.
      startAutoScroll = () => {
        if (this.autoTimer || !this.autoInterval) return;
        this.autoTimer = window.setInterval(() => {
          if (!this.track || document.hidden) return;
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (this.track.scrollLeft >= max - 1) {
            this.track.scrollTo({ left: 0, behavior: this.reduceMotion ? 'auto' : 'smooth' });
          } else {
            this.move(1);
          }
        }, this.autoInterval);
      };

      stopAutoScroll = () => {
        if (this.autoTimer) { clearInterval(this.autoTimer); this.autoTimer = 0; }
      };

      resetAutoScroll = () => {
        this.stopAutoScroll();
        this.startAutoScroll();
      };
    }

    customElements.define('video-reels', VideoReels);
  }

  } catch(e) { console.error(e); }
})();
})();
